import ListPatients from "./List";

export default ListPatients;
